import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class Service extends ServiceCRUD {
  constructor() {
    super('/api/troncos');
  }
}

export default new Service();
